module.exports = __webpack_public_path__ + "img/login-1.13e9a38b.png";